import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, shareReplay } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { UserPersistenceService } from '../../core/services/userPersistence.service';


@Injectable({
    providedIn: 'root'
})
export class HomeInspectorService {

    base_API_URL = environment.API_URL;
    baseUrl = this.base_API_URL + '/api/organization/';
    Url = this.base_API_URL + '/api/homeInspection/'
    queryString: string;
    private homeInspectionProjectsInFlight = new Map<string, Observable<any>>();
    constructor(private http: HttpClient,
        private userPersistenceService: UserPersistenceService) { }

    
    getAllCountries() {
        const selectedLanguage = this.userPersistenceService.selectedLanguage;
        return this.http.get<any>(this.base_API_URL + '/api/homeInspection/getAllCountries?selectedLanguage=' + selectedLanguage);
    }
    getProjectsForHomeInspection = function (filterData: any) {
        this.queryString = this.base_API_URL + '/api/homeInspection/getProjectsForHomeInspection';
        const requestKey = JSON.stringify(filterData ?? {});
        const cachedRequest = this.homeInspectionProjectsInFlight.get(requestKey);
        if (cachedRequest) {
            return cachedRequest;
        }

        const request$ = this.http.post(this.queryString, filterData).pipe(
            shareReplay(1),
            finalize(() => this.homeInspectionProjectsInFlight.delete(requestKey))
        );

        this.homeInspectionProjectsInFlight.set(requestKey, request$);
        return request$;
    };
    getProjectsForClient(filterData) {
        this.queryString = this.base_API_URL + '/api/dashboardClient/getProjectsForClient';
        return this.http.post(this.queryString, filterData);

    }
    exportHomeInspectionProjectsToExcel = function (filterData) {
        this.queryString = this.base_API_URL + '/api/homeInspection/exportHomeInspectionProjectsToExcel';
        return this.http.post(this.queryString, filterData);
    }
    //getstatictext(selectedlanguage) {
    //    this.querystring = '/statictext?selectedlanguage=' + selectedlanguage;
    //    return this.http.get(this.servicebase + this.querystring);
    //}
}

